import { render, staticRenderFns } from "./accountOfficialdrawer.vue?vue&type=template&id=2087413a&scoped=true"
import script from "./accountOfficialdrawer.vue?vue&type=script&lang=js"
export * from "./accountOfficialdrawer.vue?vue&type=script&lang=js"
import style0 from "./accountOfficialdrawer.vue?vue&type=style&index=0&id=2087413a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2087413a",
  null
  
)

export default component.exports